import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Inspect one device and associate it with a bike
 * @primary Device detail
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/devices/$id")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
